var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notifications-panel-content"},[_c('notifications-list',{staticClass:"notifications-panel-content__list",attrs:{"unread-only":_vm.tab === 'unread',"uncleared-only":""},on:{"close":function($event){return _vm.$emit('close')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }